import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['productAccessOptions', 'prescriptionWrapper', 'prescriptionContainer', 'productSelect',
    'prescriptionErrors', 'prescriptionOnCreate', 'productsToDelete']

  static EMPTY_OPTION = 0
  static NO_EXPIRE_OPTION = 8
  static values = {
    hasUnsavedChanges: Boolean
  }

  connect() {
    $('.datetimepicker').datetimepicker({
      format: 'DD/MM/YYYY'
    }).on('dp.change', this.dpChangeActions.bind(this))

    $('.datetimepicker input').on('keydown paste', function (e) {
      e.preventDefault()
    })

    if (this.hasProductAccessOptionsTarget) {
      this.originalContent = this.productAccessOptionsTarget.innerHTML
    }

    $('[data-toggle="tooltip"]').tooltip()

    if (this.hasPrescriptionOnCreateTarget) {
      this.markAsChanged()
    }

    this.handleBeforeUnload = this._beforeUnload.bind(this)
    window.addEventListener("beforeunload", this.handleBeforeUnload)
  }

  disconnect() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload)
  }

  markAsChanged() {
    this.hasUnsavedChangesValue = true
  }

  clearChanges() {
    this.hasUnsavedChangesValue = false
  }

  _beforeUnload(event) {
    if (this.hasUnsavedChangesValue) {
      event.preventDefault()
      event.returnValue = ""
    }
  }

  toggleProductAccess(e) {
    const buttonDivs = document.getElementsByClassName('edit-access')
    const patientInfoDivs = document.getElementsByClassName('patient-info')

    for (let div of buttonDivs) {
      div.classList.toggle('hide')
    }

    if (this.productAccessOptionsTarget.classList.contains('disabled-section')) {
      this.productAccessOptionsTarget.classList.remove('disabled-section')
      Array.from(patientInfoDivs).forEach(el => {
        el.classList.add('disabled-section')
      })
    }
    else {
      this.productAccessOptionsTarget.classList.add('disabled-section')
      Array.from(patientInfoDivs).forEach(el => {
        el.classList.remove('disabled-section')
      })
    }
  }

  disableSavedProductFields() {
    const chosenSelects = document.querySelectorAll('select.chosen-select')
    chosenSelects.forEach(select => {
      select.disabled = true
      $(select).trigger("chosen:updated")
    })

    const quantityInputs = document.querySelectorAll('input[name="bio_patient_form[quantity]"]')
    quantityInputs.forEach(input => {
      input.disabled = true
    })
  }

  togglePrescription(e) {
    const access = e.target.dataset['access']

    if (access === 'full') {
      this.prescriptionContainerTarget.classList.add('hide')
    }
    else {
      this.prescriptionContainerTarget.classList.remove('hide')

      $(".chosen-select").chosen("destroy").chosen().on('change', this.prepopulateNote.bind(this))
    }
  }

  addPrescription(withDivider = true) {
    let emptySelect = null

    const selects = document.querySelectorAll('.prescription-container select.chosen-select:not([disabled])')

    for (const select of selects) {
      if (!select.value) {
        emptySelect = select
        break
      }
    }

    if (emptySelect && withDivider) {
      this.prescriptionErrorsTarget.innerHTML = ''

      this.prescriptionErrorsTarget.insertAdjacentHTML("beforeend", `
        <p>
          Product can't be blank
        </p>
      `)

      const chosenContainer = emptySelect.nextElementSibling
      if (chosenContainer && chosenContainer.classList.contains('chosen-container')) {
        chosenContainer.classList.add('is-invalid')
      }

      return
    }

    this.prescriptionErrorsTarget.innerHTML = ''

    const clonedDiv = this.clonePrescriptionDiv()

    if (withDivider) {
      const dividerDiv = this.createDivider(clonedDiv.dataset['index'])
      this.prescriptionWrapperTarget.appendChild(dividerDiv)
    }

    this.prescriptionWrapperTarget.appendChild(clonedDiv)

    $('[data-toggle="tooltip"]').tooltip()
  }

  removePrescription(e) {
    const prescriptions = document.getElementsByClassName('prescription-container')

    if (prescriptions && prescriptions.length === 1) {
      this.addPrescription(false)
    }

    const prescriptionDiv = e.target.closest('div')
    let index = prescriptionDiv.dataset['index']

    if (prescriptions && prescriptions[0].dataset['index'] === index) {
      index = prescriptions[1].dataset['index']
    }

    const productSelect = prescriptionDiv.querySelector('select[name="bio_patient_form[product_id]"]')
    const selectedProductId = productSelect.value

    const selectedOption = productSelect.options[productSelect.selectedIndex]
    const selectedProductText = selectedOption ? selectedOption.text : ''

    this.updateHiddenField(selectedProductId)

    if (selectedProductId && selectedProductText) {
      document.querySelectorAll('.prescription-container select.chosen-select:not([disabled])').forEach(select => {
        if (!Array.from(select.options).some(option => option.value === selectedProductId)) {
          const newOption = document.createElement('option')
          newOption.value = selectedProductId
          newOption.text = selectedProductText

          select.add(newOption)

          $(select).trigger('chosen:updated')
        }
      })
    }

    prescriptionDiv.parentNode.removeChild(prescriptionDiv)

    const hrDiv = document.querySelector(`[data-index="${index}"][data-name="divider"]`)

    if (hrDiv) {
      hrDiv.parentNode.removeChild(hrDiv)
    }
  }

  updateHiddenField(value) {
    let currentValue = this.productsToDeleteTarget.value

    let valuesArray = currentValue ? JSON.parse(currentValue) : []

    if (!valuesArray.includes(value)) {
      valuesArray.push(value)
    }

    this.productsToDeleteTarget.value = JSON.stringify(valuesArray)
  }

  calculateAccessExpires(e) {
    const datePicker = e.target.closest('.prescription-container').querySelector('.datetimepicker')
    const accessExpires = datePicker.querySelector('input')
    const selectedText = e.target.options[e.target.selectedIndex].text

    for (let child of datePicker.children) {
      child.classList.remove('is-invalid')
    }

    accessExpires.value = this.addTimeFromLabel(selectedText)
  }

  disableProductAccessSection(e) {
    if (this.hasPrescriptionContainerTarget) {
      this.prescriptionContainerTarget.querySelectorAll("input, select, textarea").forEach(el => {
        el.disabled = true
      })
    }

    if (this.hasProductsToDeleteTarget) {
      this.productsToDeleteTarget.disabled = true
    }

    e.target.form.submit()
  }

  submitProductAccess(e) {
    const formData = new FormData()

    const fullProductAccess = document.querySelector('input[name="bio_patient_form[full_product_access]"]:checked')
    formData.append('full_product_access', fullProductAccess.value)

    const prescriptionReminder = document.querySelector('input[name="bio_patient_form[prescription_reminder]"]:checked')
    formData.append('prescription_reminder', prescriptionReminder.value)

    if (this.hasProductsToDeleteTarget && this.productsToDeleteTarget.value) {
      formData.append('bio_patient_form[products_to_delete]', this.productsToDeleteTarget.value)
    }

    const prescriptions = document.getElementsByClassName('prescription-container')

    for (let [index, prescription] of Array.from(prescriptions).entries()) {
      prescription.querySelectorAll("input, select, textarea").forEach(el => {
        if (!el.name || ((el.type === "radio" || el.type === "checkbox") && !el.checked)) return

        const nameMatch = el.name.match(/\[([^\]]+)]$/)
        if (!nameMatch) return

        const fieldName = nameMatch[1].replace(/_\d+$/, '')

        if (fieldName === 'access_expires_in') {
          el.value = null
          return
        }

        formData.append(`bio_patient_form[prescriptions][${index}][${fieldName}]`, el.value)
      })
    }

    const url = e.target.closest('form').action

    this.prescriptionErrorsTarget.innerHTML = ''

    fetch(url, {
      method: "PATCH",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector("[name='csrf-token']").content,
        "X-Requested-With": "XMLHttpRequest"
      },
      body: formData
    })
      .then(response => {
        if (!response.ok) throw response
        return response.json()
      })
      .then(data => {
        this.clearChanges()

        const path = window.location.pathname

        if (path.includes("/prescriptions")) {
          window.location.href = path.replace(/\/prescriptions/, "")
        }
        else {
          this.toggleProductAccess()
          this.disableSavedProductFields()
        }
      })
      .catch(async data => {
        const errors = await data.json()

        const uniqueErrors = new Set()

        for (let [index, error] of errors['errors'].entries()) {
          if (Object.keys(error).length !== 0) {
            const prescription = prescriptions[index]

            for (const [key, value] of Object.entries(error)) {
              uniqueErrors.add(`${key.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())} ${value}`)

              if (key === 'product') {
                const prescriptionSelect = prescription.querySelector('#bio_patient_form_product_id_chosen')
                prescriptionSelect.classList.add('is-invalid')
              }
            }
          }
        }

        for (let error of uniqueErrors) {
          this.prescriptionErrorsTarget.insertAdjacentHTML("beforeend", `
                <p>
                  ${error}
                </p>
              `)
        }
      })
  }

  cancelProductAccess() {
    this.productAccessOptionsTarget.innerHTML = this.originalContent

    $('[data-toggle="tooltip"]').tooltip()
  }

  prepopulateNote(e) {
    const chosenContainer = e.target.nextElementSibling
    const wasInvalid = chosenContainer && chosenContainer.classList.contains('is-invalid')

    if (chosenContainer) {
      chosenContainer.classList.remove('is-invalid')
    }

    if (wasInvalid && this.hasPrescriptionErrorsTarget) {
      this.prescriptionErrorsTarget.innerHTML = ''
    }

    fetch(`/products/${e.target.options[e.target.selectedIndex].value}/recommended_dosage`)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        const container = e.target.closest('.prescription-container')
        const index = container.dataset.index

        container.querySelector(`#bio_patient_form_patient_note_${index}`).value = data['adult_dosage']
      })
  }

  dpChangeActions(e) {
    const firstChild = e.target.children[0]
    let valid = false

    if (firstChild.tagName === 'INPUT' && this.isDateValid(firstChild.value)) {
      valid = true
    }

    for (let child of e.target.children) {
      if (valid) {
        child.classList.remove('is-invalid')
      }
      else {
        child.classList.add('is-invalid')
      }
    }

    const expiresIn = e.target.closest('.prescription-container').querySelector('#bio_patient_form_access_expires_in')
    expiresIn.selectedIndex = this.constructor.EMPTY_OPTION
  }

  isDateValid(dateString) {
    const [day, month, year] = dateString.split('/').map(Number)

    const inputDate = new Date(year, month - 1, day)

    const today = new Date()
    today.setHours(0, 0, 0, 0)

    return inputDate >= today
  }

  createDivider(index) {
    const dividerDiv = document.createElement('div')
    dividerDiv.className = 'col-xs-12'
    const hrElement = document.createElement('hr')
    dividerDiv.appendChild(hrElement)
    dividerDiv.dataset['index'] = index
    dividerDiv.dataset['name'] = 'divider'

    return dividerDiv
  }

  clonePrescriptionDiv() {
    const prescriptionDivs = this.prescriptionDivs()
    const originalDiv = prescriptionDivs[prescriptionDivs.length - 1]
    const clonedDiv = originalDiv.cloneNode(true)
    const currentId = parseInt(originalDiv.dataset['index'])
    clonedDiv.id = `prescription-${currentId + 1}`
    clonedDiv.dataset['index'] = currentId + 1

    clonedDiv.querySelectorAll('label').forEach(el => {
      el.setAttribute('for', `${el.getAttribute('for')}_${currentId + 1}`)
    })

    clonedDiv.querySelectorAll('input, textarea').forEach(el => {
      if ($(el.parentNode).hasClass('datetimepicker')) {
        $(el.parentNode).datepicker('destroy')
        $(el.parentNode).datetimepicker({
          format: 'DD/MM/YYYY'
        }).on('dp.change', this.dpChangeActions.bind(this))

        const invalidElements = el.parentNode.getElementsByClassName('is-invalid')

        Array.from(invalidElements).forEach(elem => {
          elem.classList.remove('is-invalid')
        })
      }

      el.id = el.id.replace(/_\d+$/, `_${currentId + 1}`)
      el.disabled = false
      el.value = ''
    })

    clonedDiv.querySelectorAll('select').forEach(el => {
      if ($(el).hasClass('chosen-select')) {
        const chosenContainer = clonedDiv.querySelector(`#${el.id}_chosen`)
        if (chosenContainer) chosenContainer.remove()
        el.disabled = false
        el.classList.remove('chosen-disabled')

        const selectedValues = []
        document.querySelectorAll('.prescription-container select.chosen-select').forEach(select => {
          if (select.value) {
            selectedValues.push(select.value)
          }
        })

        Array.from(el.options).forEach(option => {
          if (option.value && selectedValues.includes(option.value)) {
            option.remove()
          }
        })

        el.selectedIndex = -1

        $(el).chosen({width: '100%'}).on('change', this.prepopulateNote.bind(this))
      }
      else {
        el.removeAttribute('disabled')
        el.selectedIndex = this.constructor.NO_EXPIRE_OPTION
      }
    })

    const ordersRemainingDiv = clonedDiv.querySelector('.orders-remaining')
    if (ordersRemainingDiv) {
      ordersRemainingDiv.remove()
    }

    return clonedDiv
  }

  prescriptionDivs() {
    return document.getElementsByClassName('prescription-container')
  }

  addTimeFromLabel(label) {
    const today = new Date()

    if (label === 'No expiry') {
      return null
    }

    const [amountStr, unitRaw] = label.split(' ')
    const amount = parseInt(amountStr)
    const unit = unitRaw.toLowerCase()

    const resultDate = new Date(today)

    if (['week', 'weeks'].includes(unit)) {
      resultDate.setDate(resultDate.getDate() + amount * 7)
    }
    else {
      resultDate.setMonth(resultDate.getMonth() + amount)
    }

    return resultDate.toLocaleDateString()
  }
}
